/* A wrapper Component containing all the functionality of a add/remove library button.
 * Renders its children and passes each child component an onLibraryClick and an isBookmarked prop.
 */

import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

export default class LibraryButtonWrapper extends Component {
  static propTypes = {
    source: PropTypes.oneOf([
      'news-feed',
      'search-results',
      'library',
      'coronavirus_page',
      'rankings',
    ]).isRequired,
    work: PropTypes.shape({
      id: PropTypes.number.isRequired,
      isBookmarked: PropTypes.bool.isRequired,
    }).isRequired,
    addToLibrary: PropTypes.func, // expects workId, source, callback
    removeFromLibrary: PropTypes.func, // expects workId, callback
  };

  static defaultProps = {
    addToLibrary: defaultAddToLibrary,
    removeFromLibrary: defaultRemoveFromLibrary,
  };

  constructor(props) {
    super(props);
    this.state = { fetchingBookmark: false };
  }

  render() {
    const children = Children.map(this.props.children, (child) => {
      return cloneElement(child, {
        onLibraryClick: this.onLibraryClick,
        isBookmarked: this.props.work.isBookmarked,
      });
    });

    return <div>{children}</div>;
  }

  onLibraryClick = () => {
    if (this.state.fetchingBookmark) {
      return;
    }
    this.setState({ fetchingBookmark: true });

    const { work, removeFromLibrary, addToLibrary } = this.props;

    if (work.isBookmarked) {
      removeFromLibrary(work.id, work.contentType, () =>
        this.setState({ fetchingBookmark: false }),
      );
    } else {
      let { source } = this.props;

      // TODO(jacob): standardize news feed sources
      if (source === 'news-feed') {
        source = 'news';
      }

      addToLibrary(work.id, work.contentType, source, () =>
        this.setState({ fetchingBookmark: false }),
      );
    }
  };
}

function defaultAddToLibrary(workId, contentType, source, callback) {
  let fromDownloadAt = null;
  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line eqeqeq
  if (source == 'download') {
    fromDownloadAt = new Date();
  }

  $.ajax({
    type: 'POST',
    url: $r.api_v0_bookmarks_path({
      'bookmark[content_id]': workId,
      'bookmark[source]': source,
      'bookmark[from_download_at]': fromDownloadAt,
      'bookmark[content_type]': contentType,
      subdomain_param: 'api',
    }),
  }).then(() => callback());
}

function defaultRemoveFromLibrary(workId, contentType, callback) {
  $.ajax({
    type: 'DELETE',
    url: $r.destroy_for_work_api_v0_bookmarks_path({
      content_id: workId,
      content_type: contentType,
      subdomain_param: 'api',
    }),
  }).then(() => callback());
}
